document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.featured-products-wrapper');
  if (!wrapper) return;
  
  const grid = document.querySelector('.featured-products-grid');
  const noProductsMessage = document.querySelector('#featured-no-products');
  
  const itemsPerPage = parseInt(wrapper.dataset.productsPerPage) || 4;
  const rotationSpeed = parseInt(wrapper.dataset.rotationSpeed) || 10;
  const sortBy = wrapper.dataset.sortBy || 'margin';
  
  let allProducts = [];
  let currentIndex = 0;
  let autoRotateInterval;
  
  // Wait for featured product data to load
  function waitForProducts() {
    if (window.featuredProducts && window.featuredProducts.length > 0) {
      initializeFeaturedProducts();
    } else {
      setTimeout(waitForProducts, 100);
    }
  }
  
  function initializeFeaturedProducts() {
    allProducts = [...(window.featuredProducts || [])];
    
    if (allProducts.length === 0) {
      showNoProducts();
      return;
    }
    
    // Sort products based on settings
    const sortedProducts = sortProducts(allProducts);
    allProducts = sortedProducts;
    
    // Start background loading to get ALL products
    loadAllProducts();
    
    // Show first batch immediately
    renderCurrentBatch();
    
    // Start cycling through all products
    startAutoRotate();
    
    // Setup event listeners
    setupEventListeners();
  }
  
  function sortProducts(products) {
    const availableProducts = products.filter(p => p.variants?.[0]?.available !== false);
    
    switch (sortBy) {
      case 'margin':
        return availableProducts
          .filter(p => p.compare_at_price && p.compare_at_price > p.price)
          .map(p => {
            const margin = p.compare_at_price - p.price;
            const marginPercent = (margin / p.compare_at_price) * 100;
            return { ...p, marginPercent };
          })
          .filter(p => p.marginPercent >= 20)
          .sort((a, b) => b.marginPercent - a.marginPercent);
          
      case 'price_desc':
        return availableProducts.sort((a, b) => b.price - a.price);
        
      case 'price_asc':
        return availableProducts.sort((a, b) => a.price - b.price);
        
      default:
        return availableProducts;
    }
  }
  
  function renderCurrentBatch() {
    if (!grid || allProducts.length === 0) return;
    
    grid.innerHTML = '';
    
    // Get current batch of products
    const productsToShow = [];
    for (let i = 0; i < itemsPerPage; i++) {
      const productIndex = (currentIndex + i) % allProducts.length;
      productsToShow.push(allProducts[productIndex]);
    }
    
    productsToShow.forEach(product => {
      const element = createProductElement(product);
      grid.appendChild(element);
    });
  }
  
  function createProductElement(product) {
    const price = product.price ? `${(product.price / 100).toFixed(2)}` : 'Price unavailable';
    const comparePrice = product.compare_at_price && product.compare_at_price > product.price 
      ? `${(product.compare_at_price / 100).toFixed(2)}` : null;
    const image = product.image || '/assets/no-image.png';
    const available = product.variants?.[0]?.available !== false;
    
    const priceHtml = comparePrice 
      ? `<span class="featured-sale-price">${price}</span> <span class="featured-original-price">${comparePrice}</span>`
      : price;

    const actionButton = available 
      ? `<button class="featured-quick-add-btn" data-variant-id="${product.variants?.[0]?.id || ''}" data-product-title="${(product.title || '').replace(/"/g, '&quot;')}">Quick Add</button>`
      : `<button class="featured-quick-add-btn" disabled>Sold Out</button>`;
    
    const div = document.createElement('div');
    div.className = 'featured-product-item';
    
    div.innerHTML = `
      <a href="${product.url}" class="featured-product-link">
        <img src="${image}" alt="${product.title}" loading="lazy" onerror="this.src='/assets/no-image.png';">
        <h3 class="featured-product-title">${product.title}</h3>
        <div class="featured-product-price">${priceHtml}</div>
      </a>
      <div class="featured-product-actions">
        ${actionButton}
      </div>
    `;
    
    return div;
  }
  
  function nextBatch() {
    // Move to next set of products
    currentIndex = (currentIndex + itemsPerPage) % allProducts.length;
    renderCurrentBatch();
  }
  
  function startAutoRotate() {
    if (allProducts.length > itemsPerPage) {
      autoRotateInterval = setInterval(nextBatch, rotationSpeed * 1000);
    }
  }
  
  function stopAutoRotate() {
    if (autoRotateInterval) {
      clearInterval(autoRotateInterval);
      autoRotateInterval = null;
    }
  }
  
  async function loadAllProducts() {
    console.log(`Loading additional products beyond initial ${allProducts.length}...`);
    
    // Load from multiple sources
    await Promise.all([
      loadFromCollectionPages(),
      loadFromSitemap(),
      loadFromSearch()
    ]);
    
    // Re-sort with all products
    allProducts = sortProducts(allProducts);
    
    console.log(`✅ Total products loaded: ${allProducts.length}`);
  }
  
  async function loadFromCollectionPages() {
    for (let page = 2; page <= 50; page++) {
      try {
        const response = await fetch(`/collections/all/products.json?limit=250&page=${page}`);
        if (!response.ok) break;
        
        const data = await response.json();
        if (!data.products || data.products.length === 0) break;
        
        data.products.forEach(p => {
          if (!allProducts.find(existing => existing.handle === p.handle) && p.variants?.[0]?.available) {
            allProducts.push({
              handle: p.handle,
              title: p.title,
              vendor: p.vendor || '',
              type: p.product_type || '',
              price: Math.round((p.variants[0]?.price || 0) * 100),
              compare_at_price: p.variants[0]?.compare_at_price ? Math.round(p.variants[0].compare_at_price * 100) : null,
              image: p.images[0]?.src || '',
              url: `/products/${p.handle}`,
              variants: [{ id: p.variants[0]?.id, available: p.variants[0]?.available }]
            });
          }
        });
        
        await new Promise(resolve => setTimeout(resolve, 50));
      } catch (error) {
        break;
      }
    }
  }
  
  async function loadFromSitemap() {
    try {
      const response = await fetch('/sitemap_products_1.xml');
      const xmlText = await response.text();
      const parser = new DOMParser();
      const xml = parser.parseFromString(xmlText, 'text/xml');
      
      const urls = Array.from(xml.querySelectorAll('url loc')).map(loc => loc.textContent);
      const productUrls = urls.filter(url => url.includes('/products/'));
      
      productUrls.forEach(url => {
        const handle = url.split('/products/')[1];
        if (!allProducts.find(p => p.handle === handle)) {
          allProducts.push({
            handle: handle,
            title: handle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            vendor: '',
            type: '',
            price: 0,
            image: '',
            url: url,
            variants: [{ id: Date.now() + Math.random(), available: true }]
          });
        }
      });
    } catch (error) {
      console.log('Sitemap loading skipped');
    }
  }
  
  async function loadFromSearch() {
    try {
      const response = await fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=1000');
      const data = await response.json();
      
      (data.resources?.results?.products || []).forEach(product => {
        if (!allProducts.find(p => p.handle === product.handle)) {
          allProducts.push({
            handle: product.handle,
            title: product.title,
            vendor: product.vendor || '',
            type: product.product_type || '',
            price: Math.round((product.price || 0) * 100),
            image: product.image || '',
            url: product.url,
            variants: [{ id: product.id, available: product.available }]
          });
        }
      });
    } catch (error) {
      console.log('Search API skipped');
    }
  }
  
  function setupEventListeners() {
    // Quick add buttons
    grid.addEventListener('click', (e) => {
      if (e.target.classList.contains('featured-quick-add-btn') && !e.target.disabled) {
        handleQuickAdd(e.target);
      }
    });
    
    // Pause on hover
    wrapper.addEventListener('mouseenter', stopAutoRotate);
    wrapper.addEventListener('mouseleave', startAutoRotate);
  }
  
  function handleQuickAdd(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    
    const original = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(() => {
      button.textContent = '✅ Added!';
      
      if (typeof window.updateHeaderCartCount === 'function') {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => window.updateHeaderCartCount(cart.item_count))
          .catch(() => {});
      }
      
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 2000);
    })
    .catch(() => {
      button.textContent = '❌ Error';
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 2000);
    });
  }
  
  function showNoProducts() {
    if (grid) grid.innerHTML = '';
    if (noProductsMessage) noProductsMessage.style.display = 'block';
  }
  
  // Initialize
  waitForProducts();
});